/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ButtonIcon/view.blocks to change it.
import Children from 'Simple/Children'
import React from 'react'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function ButtonIcon({
  children,
  viewPath = "/DesignSystem/ButtonIcon",
  marginLeft = 0,
  onClick,
  onMouseEnter,
  onMouseLeave,
  isSelected
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({onMouseEnter,onMouseLeave})
  return (<React.Fragment
>
<button
  data-testid="ButtonIcon.ButtonIcon"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 onMouseEnter={onMouseEnter}
 onMouseLeave={onMouseLeave}
 style={{'--ml-1-Z2ilrAV': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--bc-3-Z2ilrAV': isHovered ? "rgba(0,147,201, 0.05)" : "#ffffff",'--bc-2-Z2ilrAV': isHovered ? "rgba(0,147,201, 0.83)" : "#ebebeb"}}
 className={`views-block ${styles.ButtonIcon1}`}
>
<Children
  viewPath={`${viewPath}/Children`}
 isSelected={isSelected} isHovered={isHovered} isSelectedHovered={isSelectedHovered}
>
{children}
</Children>
</button>
</React.Fragment>)
}